export default __webpack_public_path__ + "static/cf29548c2909b38b62db05394abbae00.jpg";